import React, { useEffect, useMemo, useState } from 'react';
import { FaArrowLeft } from 'react-icons/fa6';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

import BarraInferiorBotoes from '../../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../../components/BarraSubAbas';
import ContainerConteudo from '../../../../../components/ContainerConteudo';
import { CustomSwal } from '../../../../../components/CustomFeedback/CustomSwal';
import StyledLink from '../../../../../components/Link';
import Log from '../../../../../components/Log/Log';
import ResponsavelAquisicaoComponente from '../../../../../components/ResponsavelAquisicao';
import SubAbas from '../../../../../components/SubAbas';
import TramitacaoComponente from '../../../../../components/Tramitacao';
import WorkspaceBotoes from '../../../../../components/WorkspaceBotoes';
import WorkspaceFicha from '../../../../../components/WorkspaceFicha';
import { getUser } from '../../../../../modules/contexts/Auth/RequireAuth';
import { useSelect } from '../../../../../modules/contexts/Select/useSelect';
import { useNomeCompleto } from '../../../../../modules/contexts/userContexts';
import { ResponsavelAquisicao } from '../../../../../modules/types/Aquisicao';
import { EnumOption, LogData } from '../../../../../modules/types/types';
import { getAllResponsaveisPorEntidade } from '../../../../../services/aquisicoes/responsavelService';
import { getAllFornecedores } from '../../../../../services/fornecedoresDAF/fornecedorService';
import { isHttpError } from '../../../../../services/httpClient';
import { getItensByProaqId } from '../../../../../services/processosAquisitivos/proaqItemService';
import {
  deleteProaq,
  getProaq,
  updateProaq,
  createProaq,
} from '../../../../../services/processosAquisitivos/proaqService';
import { getDenominacaoGenerica } from '../../../../../services/produtosDAF/denominacoesGenericasService';
import {
  getKitDeProduto,
  getProdutosDoKit,
} from '../../../../../services/produtosDAF/kitProdutoService';
import { getProdutosByDenominacaoGenericaId } from '../../../../../services/produtosDAF/produtosDafService';
import {
  formataNomeMeioSiglas,
  formatarNumero,
  formatDateIntl,
  formatValorDinheiro,
  newLocalDate,
} from '../../../../../utils/functions';
import {
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../../utils/swal';
import { SubAbasProaq, SubAbasProaqId } from '../../subabas';
import DadosAdministrativos from '../Components/DadosAdministrativos';
import ItensAquisicao from '../Components/ItensAquisicao';
import ObservacoesGerais from '../Components/ObservacoesGerais';
import PesquisaPreco from '../Components/PesquisaPreco';

const ProaqFicha: React.FC = () => {
  // Gatilho para atualização do Log
  const [refreshTriggerLog, setRefreshTriggerLog] = useState(0);
  const triggerRefresh = () => setRefreshTriggerLog((prev) => prev + 1);

  // Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const userComponenteAFLabel =
    user?.vinculo?.[0]?.nomeInstituicao ?? 'Não informado';
  const { isLoading } = useNomeCompleto();

  const navigate = useNavigate();
  const location = useLocation();
  const locationData = location.state;

  const params = useParams();
  const fichaID = String(params.id);

  // Dados do módulo
  const { getSelectDominioPai } = useSelect();
  const statusProaqOptions = getSelectDominioPai(52);
  const componenteAFoptions = getSelectDominioPai(1);
  const modalidadeAquisicaoOptions = getSelectDominioPai(133);
  const submodalidadeDispensaOptions = getSelectDominioPai(139);
  const submodalidadeSrpOptions = getSelectDominioPai(139);

  const [responsavelId, setResponsavelId] = useState<number>(0);
  const [responsaveisData, setResponsaveisData] = useState<
    ResponsavelAquisicao[]
  >([]);
  const [updating, setUpdating] = useState<boolean>(false);
  const [logProaqData, setLogProaqData] = useState<LogData>();
  const [itensData, setItensData] = useState<any[]>([]);
  const [produtosDAFOptions, setProdutosDAFOptions] = useState<EnumOption[]>([
    { value: '0', label: 'Não informado' },
  ]);
  const [fornecedorOptions, setFornecedorOptions] = useState<EnumOption[]>([
    { value: '0', label: 'Não informado' },
  ]);

  const [fornecedoresData, setFornecedoresData] = useState<any[]>([]);
  const [formProaq, setFormProaq] = useState({
    status: 0,
    fluxoProaqId: 1,
    // fluxoProaq: '',
    componenteAF: locationData ? locationData.formProaqNew.componenteAF : 0,
    modalidade: locationData
      ? locationData.formProaqNew.modalidadeAquisicao
      : 0,
    submodalidade: locationData
      ? locationData.formProaqNew.subtipoModalidade
      : 0,
    denominacaoGenerica: '',
    denominacaoGenericaId: locationData
      ? locationData.formProaqNew.denominacaoGenericaId
      : 0,
    kitDeProdutos: '',
    kitDeProdutoDAFId: locationData
      ? locationData.formProaqNew.kitProdutosDAFId
      : 0,
    numeroSeiProaq: '',
    numeroEtp: '',
    observacoes: '',

    usuarioId: userID,
  });

  const [formProaqItem, setFormProaqItem] = useState({
    id: '',
    numeroItem: itensData ? itensData.length + 1 : 1,
    tipoCota: '',
    cmmInicial: '',
    cmmFim: '',
    cmmValorReferencia: '',
    qtdAdministrativa: '',
    qtdJudicial: '',
    qtdEstrategico: '',
    qtdOutro: '',
    valorPercentualEstrategico: '',
    isValorPercentualEstrategico: false,
    qtdTotal: '',
    fatorEmbalagem: '',
    qtdEmbalagem: '',
    coberturaDias: '',
    coberturaMeses: '',
    valorUntEmbalagem: '',
    valorTotalEstimado: '',
    observacoes: '',

    produto: '',
    produtoDAFId: 0,
    usuarioId: userID,
    proaqId: updating ? parseInt(fichaID, 10) : 0,
  });

  const [formProaqFase, setFormProaqFase] = useState({
    id: '',
    fase: 0,
    dataEntrada: '',
    dataSaida: '',
    dias: 0,
    observacoes: '',

    usuarioId: userID,
    proaqId: updating ? parseInt(fichaID, 10) : 0,
    fluxoProaqFaseId: 0,
  });

  const [formProaqResponsavel, setFormProaqResponsavel] = useState({
    id: 0,
    responsavel: '',
    outroResponsavel: '',
    dataInicio: '',
    dataFim: '',
    observacoes: '',

    usuarioId: userID,
    proaqId: updating ? parseInt(fichaID, 10) : 0,
  });

  let subAbas;

  const getUsuariosResponsaveis: string = useMemo(() => {
    return responsaveisData
      .filter((responsavel) => responsavel.status == 'S')
      .map((responsavel: ResponsavelAquisicao) =>
        responsavel.responsavel
          ? formataNomeMeioSiglas(responsavel.responsavel.nomeCompleto)
          : '',
      )
      .join(', ');
  }, [responsaveisData]);

  // Buscar dados
  const fetchData = async (id: string) => {
    try {
      const proaqData = await getProaq(id);
      const proaqItensData = await getItensByProaqId(id);
      const proaqResponsaveisData = await getAllResponsaveisPorEntidade(
        'proaq',
        parseInt(fichaID, 10),
      );

      const dataFornecedores = await getAllFornecedores();

      let produtosData;
      let newOptions;

      if (proaqData.denominacaoGenerica != null) {
        produtosData = await getProdutosByDenominacaoGenericaId(
          proaqData.denominacaoGenerica.id,
        );

        // Create new options array with unique entries
        newOptions = produtosData.map((item: any) => ({
          value: item.id,
          label: item.produtoFarmaceutico,
        }));
      }

      if (proaqData.KitProdutoDAF != null) {
        produtosData = await getProdutosDoKit(
          proaqData.KitProdutoDAF.id.toString(),
        );

        newOptions = produtosData.map((item: any) => ({
          value: item.produtoDAF.id,
          label: item.produtoDAF.produtoFarmaceutico,
        }));
      }

      const newFornecedorOptions = dataFornecedores.map((item: any) => ({
        value: item.id,
        label: item.razaoSocial,
      }));

      // Deduplicate options based on value property
      if (Array.isArray(newOptions) && newOptions.length > 0) {
        const uniqueOptions = Array.from(
          new Map(
            [...produtosDAFOptions, ...newOptions].map((item) => [
              item.value,
              item,
            ]),
          ).values(),
        );

        setProdutosDAFOptions(uniqueOptions);
      }

      const uniqueFornecedorOptions = Array.from(
        new Map(
          [...fornecedorOptions, ...newFornecedorOptions].map((item) => [
            item.value,
            item,
          ]),
        ).values(),
      );

      setFornecedoresData(dataFornecedores);
      setFornecedorOptions(uniqueFornecedorOptions);

      if (proaqData) {
        if (proaqData.proaqResponsavel) {
          setFormProaqResponsavel({
            ...formProaqResponsavel,
            id: proaqData.proaqResponsavel.id,
            responsavel: proaqData.proaqResponsavel.responsavel,
          });
          setResponsavelId(proaqData.proaqResponsavel.id);
        }
      }

      if (proaqResponsaveisData.length > 0) {
        setResponsaveisData(proaqResponsaveisData);
      }

      if (proaqItensData.length > 0) {
        setItensData(proaqItensData);
      }

      setFormProaq({
        ...formProaq,
        status: proaqData.status,
        fluxoProaqId: proaqData.__fluxoProaq__.id,
        componenteAF: proaqData.componenteAF,
        modalidade: proaqData.modalidade,
        submodalidade: proaqData.submodalidade,
        denominacaoGenerica: proaqData.denominacaoGenerica
          ? proaqData.denominacaoGenerica.denominacaoGenerica
          : null,
        denominacaoGenericaId: proaqData.denominacaoGenerica
          ? proaqData.denominacaoGenerica.id
          : null,
        kitDeProdutos: proaqData.KitProdutoDAF
          ? proaqData.KitProdutoDAF.nomeKit
          : null,
        kitDeProdutoDAFId: proaqData.KitProdutoDAF
          ? proaqData.KitProdutoDAF.id
          : null,
        numeroSeiProaq: proaqData.numeroSeiProaq,
        numeroEtp: proaqData.numeroEtp,
        observacoes: proaqData.observacoes,
      });

      setLogProaqData({
        ...logProaqData,
        id: proaqData.id,
        usuarioRegistro: proaqData.usuarioRegistro.nomeCompleto,
        usuarioAtualizacao: proaqData.usuarioAtualizacao.nomeCompleto,
        dataRegistro: proaqData.dataRegistro,
        dataAtualizacao: proaqData.dataUltimaAtualizacao,
        nEdicoes: proaqData.nEdicoes,
      });
      triggerRefresh();
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };

  const fetchDenominacaoGenericaOuKitProdutoDaf = async () => {
    try {
      if (formProaq.denominacaoGenericaId != 0) {
        const denominacaoGenericaData = await getDenominacaoGenerica(
          formProaq.denominacaoGenericaId,
        );
        setFormProaq({
          ...formProaq,
          denominacaoGenerica: denominacaoGenericaData.denominacaoGenerica,
        });
      }
      if (formProaq.kitDeProdutoDAFId != 0) {
        const kitProdutoDafData = await getKitDeProduto(
          formProaq.kitDeProdutoDAFId,
        );
        setFormProaq({
          ...formProaq,
          kitDeProdutos: kitProdutoDafData.nomeKit,
        });
      }
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
    }
  };

  useEffect(() => {
    if (locationData != null) {
      fetchDenominacaoGenericaOuKitProdutoDaf();
    }
    if (fichaID !== 'undefined') {
      fetchData(fichaID);
      setUpdating(true);
    }
  }, [fichaID, locationData, isLoading]);

  function transformValorParaFloat(valor: string): number {
    if (!valor) {
      return 0;
    }
    return parseFloat(valor.replace(/\./g, ''));
  }

  // Cálculos de ProaqItem
  const calculaCoberturaDiasEMeses = useMemo(() => {
    const { cmmValorReferencia, qtdAdministrativa } = formProaqItem;
    const valorReferencia = transformValorParaFloat(cmmValorReferencia);
    const quantidade = transformValorParaFloat(qtdAdministrativa);

    let coberturaDias = 0;
    let coberturaMeses = 0;

    if (valorReferencia > 0) {
      coberturaDias = quantidade / (valorReferencia / 30);
      coberturaMeses = coberturaDias / 30;
    }

    return {
      coberturaDias: formatarNumero(Math.trunc(coberturaDias).toString()),
      coberturaMeses: formatarNumero(Math.trunc(coberturaMeses).toString()),
    };
  }, [formProaqItem.cmmValorReferencia, formProaqItem.qtdAdministrativa]);

  const calculaQtdEmbalagem = useMemo(() => {
    const { qtdAdministrativa, fatorEmbalagem } = formProaqItem;

    const fator = transformValorParaFloat(fatorEmbalagem.toString());
    const quantidade = transformValorParaFloat(qtdAdministrativa);

    let embalagens = 0;

    if (fator > 0) {
      embalagens = quantidade / fator;
    }

    return formatarNumero(Math.ceil(embalagens).toString());
  }, [formProaqItem.qtdAdministrativa, formProaqItem.fatorEmbalagem]);

  const calculaQuantidadeTotalItens = useMemo(() => {
    const { qtdAdministrativa, qtdEstrategico, qtdOutro, qtdJudicial } =
      formProaqItem;
    const qtdAdministrativaNumber = transformValorParaFloat(qtdAdministrativa);
    const qtdJudicialNumber = transformValorParaFloat(qtdJudicial);
    const qtdEstrategicoNumber = transformValorParaFloat(qtdEstrategico);
    const qtdOutroNumber = transformValorParaFloat(qtdOutro);

    const total =
      qtdAdministrativaNumber +
      qtdJudicialNumber +
      qtdEstrategicoNumber +
      qtdOutroNumber;

    return formatarNumero(Math.ceil(total).toString());
  }, [
    formProaqItem.qtdAdministrativa,
    formProaqItem.qtdEstrategico,
    formProaqItem.qtdJudicial,
    formProaqItem.qtdOutro,
  ]);

  const calculaValorTotalEstimado = useMemo(() => {
    const { qtdTotal, valorUntEmbalagem } = formProaqItem;
    const valorUnitario = parseFloat(valorUntEmbalagem);
    const quantidade = transformValorParaFloat(qtdTotal);

    let valorTotal = 0;

    if (valorUnitario > 0) {
      valorTotal = quantidade * valorUnitario;
    }

    return valorTotal.toFixed(2);
  }, [formProaqItem.qtdTotal, formProaqItem.valorUntEmbalagem]);

  // Cálculos de ProaqFase
  const calculateDaysDifference = (
    startDate: string,
    endDate: string | null,
  ): number => {
    if (!startDate) return 0;

    const start = new Date(formatDateIntl(startDate));
    if (isNaN(start.getTime())) return 0;

    const end = endDate
      ? new Date(formatDateIntl(endDate))
      : new Date(newLocalDate());
    if (endDate && isNaN(end.getTime())) {
      const today = new Date(newLocalDate());
      const diffTimeFromToday = Math.abs(today.getTime() - start.getTime());

      return Math.ceil(diffTimeFromToday / (1000 * 60 * 60 * 24));
    }

    //
    const diffTime = Math.abs(end.getTime() - start.getTime());

    return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  };

  // Calcula Quantidade do Estoque Estratégico através de porcentagem de Quantidade Administrativa
  useEffect(() => {
    const { qtdAdministrativa, valorPercentualEstrategico } = formProaqItem;
    const qtdAdministrativaFloat = transformValorParaFloat(qtdAdministrativa);
    const valorPercentualEstrategicoFloat = transformValorParaFloat(
      valorPercentualEstrategico,
    );
    if (qtdAdministrativaFloat === 0) return;

    const qtdEstoqueEstrategico =
      (qtdAdministrativaFloat * valorPercentualEstrategicoFloat) / 100;

    setFormProaqItem((prev) => ({
      ...prev,
      qtdEstrategico: formatarNumero(
        Math.ceil(qtdEstoqueEstrategico).toString(),
      ),
    }));
  }, [
    formProaqItem.valorPercentualEstrategico,
    formProaqItem.isValorPercentualEstrategico,
  ]);

  useEffect(() => {
    const { dataEntrada, dataSaida } = formProaqFase;
    const dias = calculateDaysDifference(dataEntrada, dataSaida) + 1;
    setFormProaqFase((prev) => ({
      ...prev,
      dias: dias,
    }));
  }, [formProaqFase.dataEntrada, formProaqFase.dataSaida]);

  // Efeito para atualizar o formProaqItem com os valores calculados
  useEffect(() => {
    setFormProaqItem((prev) => ({
      ...prev,
      coberturaDias: calculaCoberturaDiasEMeses.coberturaDias,
      coberturaMeses: calculaCoberturaDiasEMeses.coberturaMeses,
      qtdEmbalagem: calculaQtdEmbalagem.toString(),
      qtdTotal: calculaQuantidadeTotalItens,
      valorTotalEstimado: calculaValorTotalEstimado,
    }));
  }, [
    calculaCoberturaDiasEMeses,
    calculaQtdEmbalagem,
    calculaQuantidadeTotalItens,
    calculaValorTotalEstimado,
  ]);

  if (fichaID !== 'undefined') {
    subAbas = SubAbasProaqId(fichaID);
  } else {
    subAbas = SubAbasProaq;
  }

  const handleChange = (
    event: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    const { name, value } = event.target;
    const newValue = parseInt(value, 10);
    if (name == 'status') {
      setFormProaq({ ...formProaq, status: newValue });
    } else {
      setFormProaq((prev) => ({ ...prev, [name]: value }));
    }
  };

  // CRUD PROAQ

  const validateFormProaq = (form: any): boolean => {
    const erros: string[] = [];

    if (Number(form.status) === 0) {
      erros.push('<b>Status</b> é obrigatório.');
    }

    if (!form.numeroSeiProaq) {
      erros.push('<b>Nº Processo Sei</b> é obrigatório.');
    } else if (form.numeroSeiProaq.replace(/\D/g, '').length < 17) {
      erros.push('<b>Nº Processo Sei</b> inválido.');
    }

    if (erros.length > 0) {
      swalAttention(erros.join('<br>'));
      return false;
    }

    return true;
  };

  const handleCreate = async () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar ACTs.',
        showConfirmButton: true,
      });
      return;
    }
    try {
      const formAjustado = {
        ...formProaq,
        numeroEtp: formProaq.numeroEtp || 'N/I',
        responsavelId: responsavelId,
        tipoItemAquisitivo: formProaq.denominacaoGenericaId > 0 ? 1 : 2,
      };

      const isFormValid = validateFormProaq(formAjustado);
      if (isFormValid === false) {
        return;
      }

      const response = await createProaq(formAjustado);

      swalSave();
      // fetchData(fichaID);
      setTimeout(
        () =>
          navigate(`/daf/proaq/processos/${response.registro.id}/dadosgerais`),
        2500,
      );
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleUpdate = async () => {
    if (
      ['Gabinete', 'Coordenação de Fiscalização de Contratos'].includes(
        userComponenteAFLabel,
      )
    ) {
      CustomSwal.show({
        type: 'warning',
        title: 'Atenção',
        html: 'Usuários vinculados ao Gabinete ou à Coordenação de Fiscalização de Contratos não podem criar ACTs.',
        showConfirmButton: true,
      });
      return;
    }
    try {
      const formAjustado = {
        ...formProaq,
        responsavelId: responsavelId,
        tipoItemAquisitivo: formProaq.denominacaoGenerica ? 1 : 2,
        denominacaoGenerica: formProaq.denominacaoGenericaId,
      };

      const isFormValid = validateFormProaq(formAjustado);
      if (!isFormValid) throw new Error('Formulário inválido.');

      const response = await updateProaq(fichaID, formAjustado);

      swalAtualizacao('Sucesso', response.message);
      fetchData(response.registroAtualizado.id);
    } catch (error) {
      if (isHttpError(error)) {
        CustomSwal.show({
          type: 'error',
          title: 'Erro ao salvar registro',
          html: error.response?.data?.message,
        });
        return;
      }

      CustomSwal.show({
        type: 'error',
        title: 'Erro inesperado',
        html: 'Não foi possível concluir a operação.',
      });
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await deleteProaq(fichaID);
        swalDeleteConfirm();
        setTimeout(() => {
          navigate('/daf/proaq/processos');
        }, 2000);
      } catch (error: any) {
        const errorMessage =
          error.message ||
          'Não foi possível excluir o registro. Tente novamente.';
        swalErro(errorMessage);
      }
    }
  };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/proaq/processos"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <WorkspaceFicha>
          {fichaID !== 'undefined' && (
            <Log
              {...logProaqData}
              entity="TB_PROAQ"
              id={Number(fichaID)}
              refreshTriggerLog={refreshTriggerLog}
            />
          )}

          {/* Dados Administrativos */}
          <DadosAdministrativos
            formProaq={formProaq}
            proaqStatusOptions={statusProaqOptions}
            componenteAFOptions={componenteAFoptions}
            tipoModalidadeOptions={modalidadeAquisicaoOptions}
            subtipoModalidadeData={submodalidadeDispensaOptions}
            subtipoModalidadeSrpData={submodalidadeSrpOptions}
            getUsuariosResponsaveis={getUsuariosResponsaveis}
            itensData={itensData}
            formatValorDinheiro={formatValorDinheiro}
            handleChange={handleChange}
          />

          {fichaID !== 'undefined' && (
            <>
              {/* Seção ProaqItem */}
              <ItensAquisicao
                fichaID={fichaID}
                userID={userID}
                denominacaoGenericaId={formProaq.denominacaoGenericaId}
                kitDeProdutoDAFId={formProaq.kitDeProdutoDAFId}
                produtosDAFOptions={produtosDAFOptions}
                onItensChange={setItensData}
              />

              {/* Seção Pesquisa Preço */}
              <PesquisaPreco
                fichaID={fichaID}
                userID={userID}
                produtosDAFOptions={produtosDAFOptions}
                fornecedorOptions={fornecedorOptions}
                fornecedoresData={fornecedoresData}
              />

              {/* Seção Responsáveis da Aquisição */}
              <ResponsavelAquisicaoComponente tab="proaq" id_tab={fichaID} />

              {/* Seção Tramitação */}
              <TramitacaoComponente id_tab={fichaID} tab="proaq" />
            </>
          )}

          {/* Seção Observações Gerais */}
          <ObservacoesGerais
            fechado={fichaID === 'undefined'}
            value={formProaq.observacoes}
            onChange={handleChange}
          />
        </WorkspaceFicha>
      </ContainerConteudo>

      <BarraInferiorBotoes>
        {fichaID !== 'undefined' ? (
          <WorkspaceBotoes
            delete
            onClickDelete={handleDelete}
            // pdf
            save
            onClickSave={handleUpdate}
          />
        ) : (
          <WorkspaceBotoes save onClickSave={handleCreate} />
        )}
      </BarraInferiorBotoes>
    </>
  );
};

export default ProaqFicha;
